module.exports = __webpack_public_path__ + "img/portifolio_renovavel.573b5bac.jpg";